import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/jnu-logo.svg'


const _hoisted_1 = { class: "site-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "footer-links" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "© 2025 - 2026 AI StockLink. All Rights Reserved.", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/download",
          class: "footer-link"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("下载 App", -1)
          ]))]),
          _: 1
        }),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "divider" }, "|", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("a", {
          href: "https://gupiao.yaozhineng.com",
          target: "_blank",
          rel: "noopener noreferrer"
        }, "网站状态监测", -1))
      ]),
      _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"beian-info\" data-v-19f2df6f><img src=\"" + _imports_0 + "\" alt=\"暨大Logo\" style=\"height:1.2rem;vertical-align:middle;margin-right:6px;\" data-v-19f2df6f><span class=\"team-info\" data-v-19f2df6f>暨大团队研发</span><span style=\"margin:0 8px;color:var(--text-tertiary);\" data-v-19f2df6f>|</span><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-19f2df6f>粤ICP备2026026873号-2</a></div>", 1))
    ])
  ]))
}